import { Box, Button, FormHelperText, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContainer } from '../components/auth-container.component';
import { VerificationCodeInput } from '../components/verification-code-input.component';

export function AuthCodePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = String(searchParams.get('email'));
  const error = String(searchParams.get('error'));
  const [code, setCode] = useState('');

  const handleBackClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    navigate('/auth');
  };

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          color: '#02344C',
          fontWeight: 700,
          mb: 0.75,
          textAlign: 'center',
          letterSpacing: '-0.01em',
        }}
      >
        Verifizierung
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          mb: 1,
          textAlign: 'center',
          maxWidth: 340,
          lineHeight: 1.6,
        }}
      >
        Überprüfen Sie Ihre E-Mail Adresse und geben Sie den
        Verifizierungscode ein, um fortzufahren.
      </Typography>
      <AuthContainer component="form">
        <VerificationCodeInput
          code={code}
          setCode={setCode}
          callback={() => {
            navigate(
              `/auth/sign-up?email=${encodeURIComponent(email)}&code=${code}`,
            );
          }}
        />
        {error === 'invalid_code' && (
          <FormHelperText error>
            Der Code ist ungültig. Bitte überprüfen Sie Ihre Eingabe und
            versuchen Sie es erneut.
          </FormHelperText>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            width: '100%',
            gap: 1.5,
            mt: 1,
          }}
        >
          <Button
            onClick={handleBackClick}
            fullWidth
            variant="outlined"
            sx={{
              py: 1.25,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Zurück
          </Button>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              py: 1.25,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.9rem',
            }}
          >
            Weiter
          </Button>
        </Box>
      </AuthContainer>
    </>
  );
}
